import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class EmiPaymentService {
  private EMI_LIST: any = null;
  private endpoint: 'emi-plans' | 'CCAvenueEMI' = 'emi-plans';
  constructor(private http: HttpService) { }

  setEndpoint(endpoint: 'emi-plans' | 'CCAvenueEMI') {
    this.endpoint = endpoint;
  }
  getEndpoint(): 'emi-plans' | 'CCAvenueEMI' {
    return this.endpoint;
  }

  LISTEMIPAYMENT(bookingId: string, pgId: string, EMI_CARD_PAYMENT_TYPE: any): Observable<any> {
    // if (this.EMI_LIST) return of(this.EMI_LIST);
    
    const endpoint = this.getEndpoint();
    const url = endpoint === 'emi-plans' ? `pg/booking-api/emi-plans` : `pg/bookingApi/CCAvenueEMI`;
    const payload = endpoint === 'emi-plans'
      ? { booking_id: bookingId, pg_id: pgId, emi_flag: 'payment_emi', payment_type: EMI_CARD_PAYMENT_TYPE?.value }
      : { id: bookingId, emi_flag: 'payment_emi' };
    return this.http.flightsave(url, payload).pipe(
      map(res => this.transformEMIData(res, endpoint)),
      tap(res => {
        if (!this.EMI_LIST) {
          this.EMI_LIST = {};
        }
        this.EMI_LIST[payload.payment_type] = res;
      }),
      catchError(error => throwError(() => new Error('Something went wrong. Please try again.')))
    );


    // return this.http.flightsave(url, payload).pipe(
    //   map(res => this.transformEMIData(res, endpoint)),
    //   tap(res => this.EMI_LIST = res),
    //   catchError(error => throwError(() => new Error('Something went wrong. Please try again.')))
    // );
  }
    
    private transformEMIData(res: any, endpoint: string): any {
    if (endpoint === 'emi-plans') {
      return {
        emiBanks: (res?.data?.emi_banks || []).map(bank => ({
          planId: bank.bank_id,
          gtwName: bank.bank_name,
          bankCode: bank.bank_code,
        })),
        emiPlans: (res?.data?.emi_plans || []).map(plan => ({
          tenureMonths: plan.tenure_months,
          processingFeeTypeId: plan.processing_fee_type_id,
          processingFeeType: plan.processing_fee_type,
          interestRate: plan.interest_rate,
          processingFee: plan.processing_fee,
          planId: plan.bank_id,
          tenureId: plan.tenure_id,
          emiAmount: plan.emi_amount,
          total: plan.total,
          currency: plan.currency,
          type: 'emi-plans'
        })),
        pay_opt: res?.data?.pay_opt || ''
      };
    } else {
      const emiIndex = res?.data?.findIndex(i => i.EmiBanks);
      if (emiIndex !== -1) {
        const emiBanks = JSON.parse(res?.data?.[emiIndex]?.EmiBanks || '[]').map(bank => ({
          planId: bank.planId,
          gtwName: bank.gtwName,
          bankCode: bank.bank_code,
        }));
        const emiPlans = JSON.parse(res?.data?.[emiIndex]?.EmiPlans || '[]').map(plan => ({
          tenureMonths: plan.tenureMonths,
          processingFeeTypeId: plan.processingFeeTypeId,
          processingFeeType: plan.processingFeeType,
          interestRate: plan.processingFeePercent,
          processingFee: plan.emiProcessingFee,
          planId: plan.planId,
          tenureId: plan.tenureId,
          emiAmount: plan.emiAmount,
          total: plan.total,
          currency: plan.currency,
          type: 'CCAvenueEMI'
        }));
        return {
          emiBanks,
          emiPlans,
          pay_opt: res?.data?.[emiIndex]?.payOpt || ''
        };
      }
    }
    return { emiBanks: [], emiPlans: [], pay_opt: '' };
  }

  getPaymentFormData(
    list_select_listItem: any,
    listSelectEMIs: any,
    emi_card_details: any,
    GSTInformation?: any
  ): URLSearchParams {
    // console.log(emi_card_details);
    
    let body = new URLSearchParams();
    if(listSelectEMIs.type === 'CCAvenueEMI') {
      body.set('payment[payment_type]', 'EMI');
      body.set('payment[value][payment_option]', 'OPTEMI');
      body.set('payment[value][planId]', list_select_listItem.planId);
      body.set('payment[value][emi_tenure_id]', listSelectEMIs.tenureId);
      body.set('payment[value][currency]', listSelectEMIs.currency);
      body.set('payment[value][card_number]', emi_card_details.value.emi_card_number);
      body.set('payment[value][exp_month]', emi_card_details.value.emi_card_exp_month);
      body.set('payment[value][exp_year]', emi_card_details.value.emi_card_exp_year);
      body.set('payment[value][cvv]', emi_card_details.value.emi_card_cvv);
      body.set('payment[value][name]', emi_card_details.value.emi_card_holder_name);
      body.set('payment[value][issuing_bank]', list_select_listItem.bankCode);
      body.set('payment[value][type]', emi_card_details.value.emi_card_type);
      body.set('payment[value][category]', 'EMI');
      body.set('payment[value][payOption]', '6');
      body.set('CCAvenueEmi[payment_option]', 'OPTEMI');
      body.set('CCAvenueEmi[planId]', list_select_listItem.planId);
      body.set('CCAvenueEmi[emi_tenure_id]', listSelectEMIs.tenureId);
      body.set('CCAvenueEmi[currency]', listSelectEMIs.currency);
      body.set('CCAvenueEmi[card_number]', emi_card_details.value.emi_card_number);
      body.set('CCAvenueEmi[exp_month]', emi_card_details.value.emi_card_exp_month);
      body.set('CCAvenueEmi[exp_year]', emi_card_details.value.emi_card_exp_year);
      body.set('CCAvenueEmi[cvv]', emi_card_details.value.emi_card_cvv);
      body.set('CCAvenueEmi[name]', emi_card_details.value.emi_card_holder_name);
      body.set('CCAvenueEmi[issuing_bank]', list_select_listItem.bankCode);
      body.set('CCAvenueEmi[type]', emi_card_details.value.emi_card_type);
      body.set('CCAvenueEmi[category]', 'EMI');
      body.set('CCAvenueEmi[payOption]', '6');
      body.set('payment[value][emi_payment_type]', '2');
      if (GSTInformation && Object.keys(GSTInformation).length > 0) {
        body.set('payment[value][gst][gst_in]', GSTInformation.gst_customer_number || '');
        body.set('payment[value][gst][company_name]', GSTInformation.gst_company_name || '');
        body.set('payment[value][gst][email]', GSTInformation.gst_email_id || '');
      }
      if(emi_card_details?.value?.EMI_OFFER_PAYMENT?.lenght > 0) {
        body.set("pgoffer[code]", emi_card_details?.value?.EMI_OFFER_PAYMENT?.key);
        body.set("pgoffer[pg_id]", '2');
      }
    } else {
      body.set('payment[payment_type]', 'EMI');
      body.set('payment[value][payment_option]', 'OPTEMI');
      body.set('payment[value][planId]', list_select_listItem.planId);
      body.set('payment[value][emi_tenure_id]', listSelectEMIs.tenureMonths);
      body.set('payment[value][currency]', listSelectEMIs.currency);
      body.set('payment[value][card_number]', emi_card_details.value.emi_card_number);
      body.set('payment[value][exp_month]', emi_card_details.value.emi_card_exp_month);
      body.set('payment[value][exp_year]', emi_card_details.value.emi_card_exp_year);
      body.set('payment[value][cvv]', emi_card_details.value.emi_card_cvv);
      body.set('payment[value][name]', emi_card_details.value.emi_card_holder_name);
      body.set('payment[value][issuing_bank]', list_select_listItem.bankCode); // list_select_listItem.gtwName
      body.set('payment[value][type]', emi_card_details.value.emi_card_type); // emi_card_details.value.emi_card_type
      body.set('payment[value][category]', 'EMI');
      body.set('payment[value][payOption]', '6');
      body.set('payment[value][emi_payment_type]', '2');
      if (GSTInformation && Object.keys(GSTInformation).length > 0) {
        body.set('payment[value][gst][gst_in]', GSTInformation.gst_customer_number || '');
        body.set('payment[value][gst][company_name]', GSTInformation.gst_company_name || '');
        body.set('payment[value][gst][email]', GSTInformation.gst_email_id || '');
      }
      body.set("pgoffer[code]", emi_card_details?.value?.EMI_OFFER_PAYMENT?.key);
      body.set("pgoffer[pg_id]", '2');
      if(emi_card_details?.value?.EMI_OFFER_PAYMENT?.lenght > 0) {
      }
    }
    return body
  }

  GET_CARD_LIST_EMI() {
    let cards = [
      {id: 1, name: 'Credit Card', value: 1, selected: false, active: true},
      {id: 2, name: 'Debit Card', value: 2, selected: false, active: true},
      {id: 3, name: 'Cardless', value: 3, selected: false, active: false},
      {id: 4, name: 'UPI Credit Card', value: 4, selected: false, active: false},
      {id: 5, name: 'Other', value: 5, selected: false, active: false}
    ].filter(card => card.active);
    let activeCards = cards.filter(card => card.active);
    if (!activeCards.some(card => card.selected) && activeCards.length > 0) {
      activeCards[0].selected = true; // Auto-select first active card
    }
    return activeCards;
  }

  bindEMIData(d: { listItem: any; listSelectEMIs: any; EMI_OFFERS: any[] }): Observable<any> {
    const t = (d?.listSelectEMIs?.tenureId || '') + '';
    const E = (d.EMI_OFFERS || []).map(o => {
      const b = o?.supported_payment_methods?.[6];
      const m = Array.isArray(b) ? b.filter(x => (x?.payment_code || '') + '' === t) : [];
      return m.length ? { ...o, supported_payment_methods: { 6: m } } : null;
    }).filter(Boolean);
    return of({ ...d.listItem, listSelectEMIs: d.listSelectEMIs, EMI_OFFERS: E });
  }
}
